// extracted by mini-css-extract-plugin
module.exports = {"PriceText":"PriceText_PriceText___5kr9","yen":"PriceText_yen__0uzcf"};